import styled from "styled-components";

import { Newspaper } from "@styled-icons/ionicons-outline/Newspaper";
import { Home } from "@styled-icons/boxicons-regular/Home";
import { Googleclassroom } from "@styled-icons/simple-icons/Googleclassroom";
import { Paint } from "@styled-icons/boxicons-regular/Paint";
import { AddToQueue } from "@styled-icons/material/AddToQueue";
import { ChatDots } from "@styled-icons/bootstrap/ChatDots";
import { Users } from "@styled-icons/fa-solid/Users";
import { LogoutBox } from "@styled-icons/remix-line/LogoutBox";
import { PeopleSettings } from "@styled-icons/fluentui-system-filled/PeopleSettings";
import { Menu } from "@styled-icons/heroicons-outline/Menu";
import { CreditCard } from "@styled-icons/boxicons-regular/CreditCard";
import { Wallet } from "@styled-icons/boxicons-regular/Wallet";
import { Book } from "@styled-icons/boxicons-regular/Book";
import { BarChart } from "@styled-icons/boxicons-regular/BarChart";
import { UserCircle } from "@styled-icons/heroicons-outline/UserCircle";
import { FileEarmarkText } from "@styled-icons/bootstrap/FileEarmarkText";
import { EnvelopeOpen } from "@styled-icons/bootstrap/EnvelopeOpen";

// Header fixo no topo
export const TopHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: linear-gradient(135deg, #024995 0%, #009bd9 60%, #009bd9 100%);
  color: white;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: 0 16px;
  z-index: 1000;
  box-shadow: 0 2px 16px rgba(2, 73, 149, 0.35);
  gap: 12px;

  @media (max-width: 767px) {
    height: 64px;
    padding: 0 10px;
    gap: 8px;
  }

  @media print {
    display: none !important;
  }
`;

// Botão toggle para abrir/fechar sidebar
export const MenuToggle = styled.button<{ isOpen: boolean }>`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background-color 0.2s;
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  order: 0;
  flex-shrink: 0;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
  }

  &::before,
  &::after {
    content: '';
    background-color: white;
    transition: all 0.3s ease;
    border-radius: ${props => props.isOpen ? '0' : '50%'};
  }

  &::before {
    width: ${props => props.isOpen ? '20px' : '5px'};
    height: ${props => props.isOpen ? '2px' : '5px'};
  }

  &::after {
    width: ${props => props.isOpen ? '20px' : '5px'};
    height: ${props => props.isOpen ? '2px' : '5px'};
  }

  span {
    background-color: white;
    transition: all 0.3s ease;
    width: ${props => props.isOpen ? '20px' : '5px'};
    height: ${props => props.isOpen ? '2px' : '5px'};
    border-radius: ${props => props.isOpen ? '0' : '50%'};
  }
`;

// Container do logo
export const LogoContainer = styled.div<{ sidebarOpen: boolean }>`
  display: flex;
  align-items: center;
  flex: 1;
  /*
    Sem min-width: 0 o item flex nao encolhe abaixo da largura natural do logo, e a
    barra inteira estoura a tela no celular — o que inflava a viewport de layout e
    quebrava o dimensionamento de qualquer elemento fixed (modais, por exemplo).
  */
  min-width: 0;

  a {
    display: flex;
    align-items: center;
    background: white;
    border-radius: 10px;
    padding: 4px 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: opacity 0.2s ease;
    min-width: 0;

    img {
      height: 36px;
      width: auto;
      max-width: 100%;
      display: block;
      object-fit: contain;
    }

    &:hover {
      opacity: 0.85;
    }
  }

  @media (max-width: 640px) {
    a {
      padding: 4px 8px;

      img {
        height: 30px;
      }
    }
  }
`;

// Informações do usuário
export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  flex-shrink: 0;
  margin-left: auto;

  span {
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    opacity: 0.92;
    padding: 0 8px;

    @media (max-width: 767px) {
      display: none;
    }
  }

  .profile-link, .logout-link {
    color: #024995;
    background: #ffffff;
    text-decoration: none;
    padding: 7px 14px;
    border-radius: 8px;
    border: none;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);

    /* Mobile: só ícone, sem texto */
    @media (max-width: 767px) {
      padding: 7px;
      font-size: 0;    /* esconde o texto */
      gap: 0;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      justify-content: center;
    }

    &:hover {
      background-color: #f0f7ff;
      color: #024995;
      text-decoration: none;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.22);
    }
  }

  .logout-link {
    color: #fff;
    background: #f39200;

    &:hover {
      background-color: #e08400;
      color: #fff;
    }
  }
`;


// Overlay para fechar sidebar no mobile
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 998;
  display: block;
  backdrop-filter: blur(2px);

  @media (min-width: 768px) {
    display: none;
  }
`;

// Sidebar principal
export const Sidebar = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 64px;
  left: ${props => props.isOpen ? '0' : '-260px'};
  width: 260px;
  height: calc(100vh - 64px);
  background: #ffffff;
  border-right: 1px solid #e8eef5;
  z-index: 999;
  transition: left 0.3s ease;
  overflow-y: auto;
  box-shadow: ${props => props.isOpen ? '4px 0 24px rgba(2, 73, 149, 0.12)' : 'none'};

  /* Scrollbar sutil */
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #d0dce8;
    border-radius: 4px;
  }

  @media print {
    display: none !important;
  }
`;

// Conteúdo da sidebar
export const SidebarContent = styled.div`
  padding: 16px 0 24px;
`;

// Seção de navegação
export const NavSection = styled.div`
  margin-bottom: 4px;
`;

// Título da seção
export const SectionTitle = styled.h6`
  color: #009bd9;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin: 20px 20px 6px;
  padding-bottom: 6px;
  border-bottom: 2px solid #e8eef5;
`;

// Item de navegação
export const NavItem = styled.div`
  .nav-link {
    display: flex;
    align-items: center;
    padding: 11px 20px;
    color: #3d5068;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    border-left: 3px solid transparent;
    gap: 2px;

    &:hover {
      background-color: #f0f7ff;
      color: #024995;
      text-decoration: none;
      border-left-color: #009bd9;
    }

    &.active {
      background-color: #e3f2fd;
      color: #024995;
      border-left-color: #024995;
      font-weight: 600;
    }
  }
`;

// Ícones — cor azul suave consistente
const iconBase = `
  color: #009bd9;
  height: 17px;
  width: 17px;
  margin-right: 10px;
  flex-shrink: 0;
`;

export const NewsPapperIcon = styled(Newspaper)`${iconBase}`;
export const PlanosIcon = styled(CreditCard)`${iconBase}`;
export const HomeIcon = styled(Home)`${iconBase}`;
export const ClassIcon = styled(Googleclassroom)`${iconBase}`;
export const TemaIcon = styled(Paint)`${iconBase}`;
export const MaterialIcon = styled(AddToQueue)`${iconBase}`;
export const ChatIcon = styled(ChatDots)`${iconBase}`;
export const UsersIcon = styled(Users)`${iconBase}`;
export const SettingsIcon = styled(PeopleSettings)`${iconBase}`;
export const PaymentIcon = styled(Wallet)`${iconBase}`;
export const BookIcon = styled(Book)`${iconBase}`;
export const ReportIcon = styled(BarChart)`${iconBase}`;
export const ContratoIcon = styled(FileEarmarkText)`${iconBase}`;
export const AvisoEntregaIcon = styled(EnvelopeOpen)`${iconBase}`;

export const LogoutIcon = styled(LogoutBox)`
  color: #ffffff;
  height: 17px;
  width: 17px;
  flex-shrink: 0;
`;

export const ProfileIcon = styled(UserCircle)`
  color: #024995;
  height: 20px;
  width: 20px;
  flex-shrink: 0;

  @media (max-width: 767px) {
    height: 20px;
    width: 20px;
  }
`;
